import React, { useState } from "react";
import axios from "./../../../utils/axiosInstance";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

function UpdatePassword() {
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const navigate = useNavigate();

  const email = localStorage.getItem("emailForVerification");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== passwordConfirmation) {
      toast.error("Password confirmation failed!");
    } else {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_BASED_URL}/auth/updatePassword`,
          { password, email }
        );
        if (response.status === 200) {
          toast.success(response.data.message);

          // Redirect to a confirmation page
          navigate("/dashboard");
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <div className="container mx-auto flex justify-center items-center h-screen">
      <div className="w-full md:w-7/12 flex flex-col items-center justify-center">
        <form
          style={{ width: "80%", maxWidth: 500 }}
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <h1 className="text-center text-3xl font-bold mb-4">
            Update your Password
          </h1>
          <div className="mb-4">
            <label
              className="block text-sm font-medium mb-2"
              htmlFor="password"
            >
              Password
            </label>
            <input
              type="password"
              className={`block w-full p-2 pl-10 text-sm text-gray-700 placeholder-gray-600 bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-green-500 focus:border-green-500`}
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-sm font-medium mb-2"
              htmlFor="password_confirmation"
            >
              Password Confirmation
            </label>
            <input
              type="password"
              className={`block w-full p-2 pl-10 text-sm text-gray-700 placeholder-gray-600 bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-green-500 focus:border-green-500`}
              name="password_confirmation"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              placeholder="Password Confirmation"
            />
          </div>
          <div className="flex justify-center mb-4 mt-8">
            <button
              type="submit"
              className="text-white bg-blue-700 hover:bg-blue-800 rounded px-4 py-2"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UpdatePassword;
